import React, { useState, useEffect } from 'react';
import { Button, Tooltip } from 'antd';

import { useNavigate, useParams } from 'react-router-dom';
import { DropdownMobile, errorCatch, GET, JSXMap, useAuth, useTranslateContext } from 'fennec-ui';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { PrinterOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import { getIndexColor, getIndexColorAlt, getIndexColorLighter } from '../../../../common/Tool';
import dayjs from 'dayjs';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../common/Context';

const Dancer = ({ dancerEvent }) => {
	return (<div style={{
		border: "1px solid transparent",
		maxWidth: "70px",
		minWidth: "70px",
		height: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		gap: "5px",
		// alignItems: "center"
	}}>
		<div style={{ flex: "0 0 14px", backgroundColor: "white", borderRadius: "3px", textAlign: "center", width: "100%", display: "flex", justifyContent: "center", gap: "5px", alignItems: "center" }}>
			{(dancerEvent?.genderID == 1 && dancerEvent?.tipTDID != 2) && <i className="fa fa-male" style={{ color: "blue", fontSize: "14px" }} />}
			{(dancerEvent?.genderID != 1 && dancerEvent?.tipTDID != 2) && <i className="fa fa-female" style={{ color: "red", fontSize: "14px" }} />}
			{(dancerEvent?.tipTDID == 2) && <Icofont icon={"users-alt-4"} style={{ color: "cadetblue", fontSize: "13px" }} />}
			{dancerEvent?.number && <span>№ <span style={{ fontWeight: "bold" }}>{dancerEvent?.number}</span></span>}
		</div>
		<div style={{ flex: "1 1 auto", textAlign: "left", fontSize: "10px", textAlign: "center" }}>
			<div>{dancerEvent?.user?.lastname}</div>
			{(dancerEvent?.tipTDID != 2) && <div>{dancerEvent?.user?.firstname}</div>}
			{/* {(dancerEvent?.tipTDID == 1) && <div>
				<div>ассистент {dancerEvent?.partner?.lastname}</div>
			</div>} */}
			{(dancerEvent?.tipTDID == 2) && <div>
				<div>{dancerEvent?.partner?.lastname}</div>
			</div>}
		</div>
	</div>)
}
const User = ({ user }) => {
	return (<div style={{
		border: "1px solid transparent",
		maxWidth: "208px",
		minWidth: "208px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "flex",
		justifyContent: "flex-start",
		gap: "5px",
		alignItems: "center"
	}}>
		<div style={{ backgroundColor: (user?.genderID === 1) ? "blue" : "red", width: "13px", height: "13px", lineHeight: "13px", borderRadius: "3px", textAlign: "center" }}>
			<Icofont icon='user' style={{ color: "white", fontSize: "8px", marginLeft: "1px" }} />
		</div>
		<div>{user?.lastname} {user?.firstname}</div>
	</div>)
}
const UserDoubleLine = ({ user }) => {
	return (<div className='bg bg-grey' style={{
		textAlign: "left",
		border: "1px solid transparent",
		height: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "flex",
		justifyContent: "flex-start",
		gap: "5px",
		alignItems: "center"
	}}>
		<div style={{ flex: "0 0 14px", backgroundColor: (user?.genderID === 1) ? "blue" : "red", height: "100%", lineHeight: "14px", borderRadius: "3px", textAlign: "center" }}>
			<Icofont icon='user' style={{ color: "white", fontSize: "8px", marginLeft: "1px" }} />
		</div>
		<div style={{ flex: "1 1 auto" }}>
			<div>{user?.lastname}</div>
			<div>{user?.firstname}</div>
		</div>
	</div>)
}
export default function EffektivnostSudeiTour(props) {
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

	let navigate = useNavigate();

	const { auth } = props;
	const { tourid } = useParams();
	const t = useTranslateContext();
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState()
	// "tour"
	// "esItogPoTuru"
	// "esItogPoSudyam"

	useEffect(() => {
		setLoading(true);

		GET(auth, `/api/report/effektivnost-sudei-po-turu/${tourid}`, ({ data }) => {
			data.dancerList = getDancerList(data?.esItogPoSudyam);
			setData(data)
			setLoading(false);
		}, (err) => errorCatch(err, () => setLoading(false)));
	}, [auth]);

	const getDancerList = (esItogPoSudyam) => {
		if (!esItogPoSudyam) {
			return []
		}

		let dancerMap = {};
		for (let i = 0; i < esItogPoSudyam?.length; i++) {
			const element = esItogPoSudyam[i];
			dancerMap[element?.tantsorID] = element?.tantsor;
		}

		let res = [];
		for (const key in dancerMap) {
			if (Object.hasOwnProperty.call(dancerMap, key)) {
				res.push(dancerMap[key])
			}
		}

		return res.sort((a, b) => (a?.dancerEvent?.number - b?.dancerEvent?.number))
	}

	const ref = useRef(null)
	if (isDesktopOrLaptop || !isMobile) {
		return (
			<div>
				<div style={{ display: "flex", justifyContent: ((data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatieID) ? "space-between" : "right"), padding: "15px 20px" }} >
					{(data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatieID) && <Button onClick={(e) => {
						navigate(`/app/reports/effektivnost-sudei/event/${data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatieID}`);
					}}>Назад</Button>}
					<ReactToPrint
						trigger={() => {
							// NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
							// to the root node of the returned component as it will be overwritten.
							return (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /> Печать</Button>)
						}}
						content={() => ref.current}
					/>
				</div>
				{(data?.esItogPoTuru) && <div className="report" style={{ padding: "0 25px" }} ref={ref}>
					{(data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie) && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "16px", marginBottom: "20px" }}>
						<div>
							<span>{data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.nazvanieMeropriyatiya}</span> - {dayjs(data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ({data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.mestoProvedeniya?.name})
						</div>
						<div>
							<span>{data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplina?.nazvanie}, </span>
							<span>{data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikov?.nazvanie}, </span>
							<span>Тур №{data?.tour?.number} ({data?.tour?.tourType?.name})</span>
						</div>
					</div>}
					<div className='scrollable' style={{ backgroundColor: "white" }}>
						<table className="table" style={{ fontSize: "13px" }}>
							<thead>
								<tr>
									<th className={`wrap fixed`} style={{ minWidth: "210px", backgroundColor: "white" }}>
										<div className='bg bg-grey dark-1'>Судья</div>
									</th>
									<th className="wrap fixed" style={{ left: "210px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-5 border-orange' style={{ fontWeight: "bold" }}>Итого по туру</div>
									</th>
									{JSXMap(data?.dancerList, (dancer, cidx) => {
										let color = getIndexColorLighter(dancer?.ID || 1, 0.25)
										return (<th className="wrap" style={{ fontWeight: "300" }} key={cidx}>
											<div className="bg bg-grey pointer" onClick={(e) => {
												navigate(`/app/reports/effektivnost-sudei/dancer/${dancer?.ID}`);
											}} style={{ backgroundColor: color }}>
												<div>
													{(dancer?.dancerEvent?.genderID == 1 && dancer?.dancerEvent?.tipTDID != 2) && <i className="fa fa-male" style={{ color: "blue", fontSize: "14px" }} />}
													{(dancer?.dancerEvent?.genderID != 1 && dancer?.dancerEvent?.tipTDID != 2) && <i className="fa fa-female" style={{ color: "red", fontSize: "14px" }} />}
													{(dancer?.dancerEvent?.tipTDID == 2) && <Icofont icon={"users-alt-4"} style={{ color: "cadetblue", fontSize: "13px" }} />}
													<span> №{dancer?.dancerEvent?.number} </span>
													<span>{dancer?.dancerEvent?.user?.lastname} {dancer?.dancerEvent?.user?.firstname}{(dancer?.dancerEvent?.tipTDID == 2) ? "," : ""} </span>
												</div>
												{(dancer?.dancerEvent?.tipTDID == 2) && <div>
													<div> {dancer?.dancerEvent?.partner?.lastname} {dancer?.dancerEvent?.partner?.firstname}</div>
												</div>}
											</div>
										</th>)
									})}
								</tr>
							</thead>
							<tbody style={{ fontSize: "12px" }}>
								{JSXMap(data?.esItogPoTuru || [], (judgeItem, cidx) => {

									return (<tr key={cidx}>
										<td className={`fixed`} style={{ minWidth: "210px", backgroundColor: "white" }}>
											<User user={judgeItem?.sudya?.user} />
										</td>
										<td className={`fixed`} style={{ left: "210px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }}>
											<div className="bg bg-orange dark-1" style={{ fontWeight: "bold" }}>
												{judgeItem?.srednee}
											</div>
										</td>
										{JSXMap(data?.dancerList, (dancer, cidx) => {
											let itemCell = data?.esItogPoSudyam?.find((el) => {
												return el?.sudyaID == judgeItem?.sudyaID &&
													el?.tantsorID == dancer?.ID
											})
											let color = getIndexColorLighter(dancer?.ID || 1, 0.14)
											return (<td className="wrap" style={{ fontWeight: "300" }} key={cidx}>
												<div className="bg bg-grey" style={{ backgroundColor: color }}>
													{(itemCell?.sredneePoDispersiyam) ? itemCell?.sredneePoDispersiyam : ""}
												</div>
											</td>)
										})}
									</tr>)
								})}
							</tbody>
						</table>
					</div>
				</div>}
			</div >);
	} else {
		return (
			<div>
				<div style={{ display: "flex", justifyContent: ((data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatieID) ? "space-between" : "right"), padding: "15px 10px" }} >
					{(data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatieID) && <Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }} onClick={(e) => {
						navigate(`/app/reports/effektivnost-sudei/event/${data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatieID}`);
					}}><i className='fa fa-chevron-left'></i></Button>}
					<ReactToPrint
						trigger={() => {
							return (<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /></Button>)
						}}
						content={() => ref.current}
					/>
				</div>
				{(data?.esItogPoTuru) && <div className="report" style={{ padding: "0 5px" }} ref={ref}>
					{(data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie) && <div style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", fontSize: "16px", marginBottom: "20px" }}>
						<div>
							<span>{data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.nazvanieMeropriyatiya}</span>
						</div>
						<div>
							<span>{dayjs(data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ({data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie?.mestoProvedeniya?.name})</span>
						</div>
						<div style={{ fontSize: "14px" }}>
							<span>{data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplina?.nazvanie}, </span>
							<span>{data?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikov?.nazvanie}</span>
							<div>Тур №{data?.tour?.number} ({data?.tour?.tourType?.name})</div>
						</div>
					</div>}
					<div className='scrollable' style={{ backgroundColor: "white" }}>
						<table className="table" style={{ fontSize: "13px" }}>
							<thead>
								<tr>
									<th className={`wrap fixed`} style={{ minWidth: "100px", backgroundColor: "white" }}>
										<div className='bg bg-grey dark-1'>Судья</div>
									</th>
									<th className="wrap fixed" style={{ left: "100px", minWidth: "55px", maxWidth: "55px", backgroundColor: "white" }}>
										<div className='bg bg-orange dark-5 border-orange' style={{ fontSize: "10px", fontWeight: "bold" }}>Итого по туру</div>
									</th>
									{JSXMap(data?.dancerList, (dancer, cidx) => {
										let color = getIndexColorLighter(dancer?.ID || 1, 0.25)
										return (<th className="wrap" style={{ fontWeight: "300", minWidth: "48px" }} key={cidx}>
											<DropdownMobile
												titles={{
													header: (<div style={{ textAlign: "center", flex: "1 1 auto" }}>
														<div>({dancer?.dancerEvent?.number}) {dancer?.dancerEvent?.user?.lastname} {dancer?.dancerEvent?.user?.firstname}{(dancer?.dancerEvent?.tipTDID == 2) ? "," : ""}</div>
														{(dancer?.dancerEvent?.tipTDID == 2) && <div>
															<div> {dancer?.dancerEvent?.partner?.lastname} {dancer?.dancerEvent?.partner?.firstname}</div>
														</div>}
													</div>),
												}}
												items={() => [{
													auth,
													readonly: false,
													title: (<div style={{ display: "flex", gap: "5px" }}>
														<div><svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 446.969 446.969"><g><path d="M430.266,23.857H16.699C7.487,23.857,0,31.354,0,40.555v365.86c0,5.654,2.841,10.637,7.155,13.663v2.632h5.989		c1.149,0.252,2.332,0.401,3.555,0.401h413.575c1.22,0,2.401-0.149,3.545-0.401h0.821v-0.251		c7.088-1.938,12.328-8.362,12.328-16.044V40.561C446.969,31.354,439.479,23.857,430.266,23.857z M66.006,408.396H15.459		c-0.674-0.416-1.148-1.132-1.148-1.98v-43.35h51.695V408.396z M66.006,348.751H14.311v-47.01h51.695V348.751z M66.006,287.432		H14.311V237.8h51.695V287.432z M66.006,223.487H14.311V169.8h51.695V223.487z M66.006,155.486H14.311v-52.493h51.695V155.486z		 M186.495,408.396H80.318v-45.33h106.176V408.396z M186.495,348.751H80.318v-47.01h106.176V348.751z M186.495,287.432H80.318V237.8		h106.176V287.432z M186.495,223.487H80.318V169.8h106.176V223.487z M186.495,155.486H80.318v-52.493h106.176V155.486z		 M186.495,88.676H80.318v-50.51h106.176V88.676z M308.19,408.396H200.812v-45.33H308.19V408.396z M308.19,348.751H200.812v-47.01		H308.19V348.751z M308.19,287.432H200.812V237.8H308.19V287.432z M308.19,223.487H200.812V169.8H308.19V223.487z M308.19,155.486		H200.812v-52.493H308.19V155.486z M308.19,88.676H200.812v-50.51H308.19V88.676z M432.656,406.416c0,0.845-0.477,1.56-1.148,1.98		H322.503v-45.33h110.153V406.416z M432.656,348.751H322.503v-47.01h110.153V348.751z M432.656,287.432H322.503V237.8h110.153		V287.432z M432.656,223.487H322.503V169.8h110.153V223.487z M432.656,155.486H322.503v-52.493h110.153V155.486z M432.656,88.676		H322.503v-50.51h107.763c1.312,0,2.391,1.073,2.391,2.389V88.676z M297.261,142.238h-85.921v-29.883h85.917v29.883H297.261z		 M297.261,209.757h-85.921v-29.882h85.917v29.882H297.261z M297.261,275.125h-85.921v-29.883h85.917v29.883H297.261z		 M297.261,339.843h-85.921v-29.878h85.917v29.878H297.261z M297.261,399.619h-85.921v-29.888h85.917v29.888H297.261z" /></g></svg></div>
														<div><span>Посмотреть таблицу по танцору</span></div>
													</div>),
													action: (values, unlock, close) => navigate(`/app/reports/effektivnost-sudei/dancer/${dancer?.ID}`),
												}]}
												trigger={(click) => (<div className="bg bg-grey pointer" onClick={click}
													style={{ backgroundColor: color, padding: "0px" }}>
													<Dancer dancerEvent={dancer?.dancerEvent} />
													{/* ({dancer?.dancerEvent?.number}) */}
													{/* <div style={{ flex: "0 0 25px" }}>({dancer?.dancerEvent?.number})</div> */}
													{/* <div style={{ flex: "1 1 auto", textAlign: "left" }}>
														<div>{dancer?.dancerEvent?.user?.lastname}</div>
														<div>{dancer?.dancerEvent?.user?.firstname}</div>
													</div> */}
												</div>)}
											/>

										</th>)
									})}
								</tr>
							</thead>
							<tbody style={{ fontSize: "12px" }}>
								{JSXMap(data?.esItogPoTuru || [], (judgeItem, cidx) => {

									return (<tr key={cidx}>
										<td className={`fixed`} style={{ minWidth: "25px", backgroundColor: "white", height: "40px" }}>
											<UserDoubleLine user={judgeItem?.sudya?.user} />
										</td>
										<td className={`fixed`} style={{ left: "100px", minWidth: "55px", maxWidth: "55px", backgroundColor: "white", height: "40px" }}>
											<div className="bg bg-orange dark-1" style={{ height: "100%", fontWeight: "bold" }}>
												{judgeItem?.srednee}
											</div>
										</td>
										{JSXMap(data?.dancerList, (dancer, cidx) => {
											let itemCell = data?.esItogPoSudyam?.find((el) => {
												return el?.sudyaID == judgeItem?.sudyaID &&
													el?.tantsorID == dancer?.ID
											})
											let color = getIndexColorLighter(dancer?.ID || 1, 0.14)
											return (<td className="wrap" style={{ fontWeight: "300", height: "40px", minWidth: "48px" }} key={cidx}>
												<div className="bg bg-grey" style={{ height: "100%", backgroundColor: color }}>
													{(itemCell?.sredneePoDispersiyam) ? itemCell?.sredneePoDispersiyam : ""}
												</div>
											</td>)
										})}
									</tr>)
								})}
							</tbody>
						</table>
					</div>
				</div>}
			</div >);
	}
}
